import React, { useState, useEffect } from 'react';
import { getImageUrl } from '../utils/imageUrl';
import config from '../config';
import API from '../services/api';

const BannierePublicitaire = ({ emplacement, className, dimensions }) => {
  const [publicites, setPublicites] = useState([]);
  const [indexActif, setIndexActif] = useState(0);

  useEffect(() => {
    API.get(`/publicites/actives/${emplacement}`)
      .then(res => setPublicites(res.data.publicites || []))
      .catch(() => setPublicites([]));
  }, [emplacement]);

  // Défilement automatique toutes les 5 secondes
  useEffect(() => {
    if (publicites.length <= 1) return;
    const interval = setInterval(() => {
      setIndexActif(prev => (prev + 1) % publicites.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [publicites]);

  if (publicites.length === 0) return null;

  const pub = publicites[indexActif];

  return (
    <div className={`relative overflow-hidden rounded-xl ${className}`}>
      {/* Badge pub */}
      <span className="absolute top-1 left-1 bg-black bg-opacity-50 text-white text-xs px-2 py-0.5 rounded-full z-10">
        Publicité
      </span>

      {/* Dimensions recommandées */}
      {dimensions && (
        <span className="absolute top-1 right-1 bg-black bg-opacity-50 text-white text-xs px-2 py-0.5 rounded-full z-10">
          {dimensions}
        </span>
      )}

      {/* Image */}
      {pub.lien ? (
        <a href={pub.lien} target="_blank" rel="noopener noreferrer" className="block w-full h-full">
          <img
            src={getImageUrl(pub.image_url)}
            alt={pub.titre}
            className="w-full h-full object-cover hover:opacity-95 transition"
          />
        </a>
      ) : (
        <img
          src={getImageUrl(pub.image_url)}
          alt={pub.titre}
          className="w-full h-full object-cover"
        />
      )}

      {/* Indicateurs si plusieurs publicités */}
      {publicites.length > 1 && (
        <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-1 z-10">
          {publicites.map((_, index) => (
            <button
              key={index}
              onClick={() => setIndexActif(index)}
              style={{ background: index === indexActif ? '#F5A623' : 'rgba(255,255,255,0.5)' }}
              className="w-2 h-2 rounded-full transition-all"
            />
          ))}
        </div>
      )}

      {/* Navigations gauche/droite si plusieurs */}
      {publicites.length > 1 && (
        <>
          <button
            onClick={() => setIndexActif(prev => (prev - 1 + publicites.length) % publicites.length)}
            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-40 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-opacity-60 transition z-10"
          >
            ‹
          </button>
          <button
            onClick={() => setIndexActif(prev => (prev + 1) % publicites.length)}
            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-black bg-opacity-40 text-white w-6 h-6 rounded-full flex items-center justify-center hover:bg-opacity-60 transition z-10"
          >
            ›
          </button>
        </>
      )}
    </div>
  );
};

export default BannierePublicitaire;